/* eslint-disable no-bitwise */
export class PermissionsModel {
  create: boolean;
  update: boolean;
  delete: boolean;
  print: boolean;
  view: boolean;

  constructor(create = false, update = false, del = false, print = false, view = false) {
    this.create = create;
    this.update = update;
    this.delete = del;
    this.print = print;
    this.view = view;
  }

  static FromBitmap(permissionBitmap: number) {
    return new PermissionsModel(
      (permissionBitmap & 0b00001) === 0b00001,
      (permissionBitmap & 0b00010) === 0b00010,
      (permissionBitmap & 0b00100) === 0b00100,
      (permissionBitmap & 0b01000) === 0b01000,
      (permissionBitmap & 0b10000) === 0b10000,
    );
  }
}

/**
 * Wrapper needed b/c Clear 1 impletemented it this way!
 */
export interface PermissionWrapperModel {
  permission: PermissionsModel;
}

/**
 * Dynamic dictionary of feature permissions keyed by feature name from the database.
 * Feature names match the dbo.Features table (e.g., "Loan", "AIO", "Pipeline").
 */
export type FeaturePermissions = Record<string, PermissionWrapperModel>;
